class Comparison extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const buttons = this.querySelectorAll('[data-comparable-button-id]');
        const items = this.querySelectorAll('[data-comparable-item-id]');
        const titles = this.querySelectorAll('[data-comparable-title-id]');

        for (const button of buttons) {
            button.addEventListener('click', () => {
                const targetId = button.dataset.comparableButtonId;

                for (const btn of buttons) {
                    if (btn === button) {
                        btn.setAttribute('data-active', '');
                    } else {
                        btn.removeAttribute('data-active');
                    }
                }

                for (const item of items) {
                    if (item.dataset.comparableItemId === targetId) {
                        item.removeAttribute('hidden');
                    } else {
                        item.setAttribute('hidden', '');
                    }
                }

                for (const title of titles) {
                    if (title.dataset.comparableTitleId === targetId) {
                        title.removeAttribute('hidden');
                    } else {
                        title.setAttribute('hidden', '');
                    }
                }
            });
        }
    }
}

customElements.define('comparison-component', Comparison);